import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TRIAL_BALANCE_REPORT_API } from "./apiRoutes";

interface UseGetTrialBalanceReportProps {
  filter: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTrialBalanceReport = async (filter: any) =>
  await axiosAuth.get(`${TRIAL_BALANCE_REPORT_API(filter?.communityId)}/gl?${new URLSearchParams(filter).toString()}`);

const useGetTrialBalanceReport = ({
  filter,
  queryParams,
}: UseGetTrialBalanceReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["trial-balance-report"],
    queryFn: () => getTrialBalanceReport(filter),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetTrialBalanceReport;
